import { render } from "./SortableColumn.vue?vue&type=template&id=ca75c962"
import script from "./SortableColumn.vue?vue&type=script&lang=js"
export * from "./SortableColumn.vue?vue&type=script&lang=js"

import "./SortableColumn.vue?vue&type=style&index=0&id=ca75c962&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__